import React, { useEffect } from "react";
import qnetLogo from "../../assets/qnet-with-text-logo.svg";
import { useMemo, useState } from "react";
import router from "../../components/routing/router";
import { set } from "lodash";
import { useNavigate } from "react-router";

interface Props {
  email: string;
  setEnterCode: (enterCode: boolean) => void;
  checkOTP: () => void;
  sendOTP: () => void;
  setAreaCode: (areaCode: string) => void;
  setForgotPassword: (forgotPassword: boolean) => void;
  setEmail: (email: string) => void;
  setUsingEmail: (usingEmail: boolean) => void;
}
const regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;


export function ForgotPassword(props: Props) {
  const navigate = useNavigate();
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [timer, setTimer] = useState(0);
  const inputRefs: React.RefObject<any>[] = useMemo(
    () =>
      Array(code.length)
        .fill(0)
        .map((i) => React.createRef()),
    [],
  );

  const handleSendCode = () => {
    setIsButtonDisabled(true);
    props.sendOTP();
    setTimer(30);

    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(countdown);
          setIsButtonDisabled(false);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  };

  const returnToLoginClicked = () => {
    props.setForgotPassword(false);
  }

  const submitForgotPasswordClicked = () => {
    handleSendCode();
  };

  const checkEmail = (e: { target: { value: string; }; }) => {
    props.setEmail(e.target.value);
    if (e.target.value.length > 0 && regex.test(e.target.value)) {
      setIsButtonDisabled(false);
    }else{
      setIsButtonDisabled(true);
    }
  }

  return (
    <div className="flex aspect-square w-full max-[768px]:w-[100%]">
      <div className="flex w-full flex-col max-[768px]:max-w-[100%]">
        <div className="flex items-center justify-start pt-[2vh]"></div>

        <div className="flex max-h-[500px] w-full flex-1 flex-col items-baseline justify-center pl-8 pr-8">
          <img
            className="mb-4 h-[100%] max-h-[85px]"
            src={qnetLogo}
            alt="QNET Logo"
          />
          <div className="flex w-[100%] items-center justify-start max-[768px]:justify-center">
            <span className="text-[32px] text-[black]">
              Welcome back to <b>Qnet™</b> 👋
            </span>
          </div>

          <div className="flex w-[100%] items-center justify-start max-[768px]:justify-center">
            <span className="text-[14px] text-[#333333]">
              {"Enter your email to get one time password sent to your email"}
            </span>
          </div>

          (
            <div className="flex w-[100%] flex-col pt-[16px]">
              <div className="label">
                <span className="label-text text-[#333333]">Email*</span>
              </div>
              <div className="flex items-center">
                <input
                  onChange={(e) => checkEmail(e)}
                  type="text"
                  placeholder="Email Address"
                  className="input input-bordered w-full border-[grey] bg-[white] text-[black]"
                />
              </div>
            </div>
          )
          <div className="flex w-[100%] items-center justify-start pt-[20px]">
            <button
              disabled={
                isButtonDisabled
              }
              onClick={() => (submitForgotPasswordClicked())}
              className="btn w-full border-none bg-[#fedd00] text-black hover:bg-[#fedd00] disabled:bg-[#fedd00] disabled:text-[black] disabled:opacity-60"
            >
              Submit
            </button>
          </div>
        </div>

        <div className="border[grey] border-b-[1px] pt-[50px]"></div>

        <div
            onClick={() => returnToLoginClicked()}
            className="flex items-center justify-center pb-[5vh] pt-[14px] text-[#fedd00] hover:cursor-pointer"
          >
            <span>Return to login page</span>
        </div>
     
      </div>
    </div>
  );
}
